import React, { RefObject } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { createPollFb } from '../db';
import { useAuth0 } from "../helpers/react-auth0-spa";
import PollPickerInput from "./PollPickerInput";
import { IAppState } from '../db/reducers';

const SForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

interface INewPollDrawer {
  setDrawerVisible: (isVis: boolean) => unknown;
  createPoll(pollId: string, pollOwner: string): void;
}

const NewPollDrawer: React.SFC<INewPollDrawer> = (props) => {
  const inputPollName: RefObject<any> = React.createRef();

  const { user } = useAuth0();
  const history = useHistory();

  const { setDrawerVisible } = props

  const startPoll = (event: any) => {
    event.preventDefault();
    const { createPoll } = props;
    const pollId: string = inputPollName.current.value;

    createPoll(pollId, user);

    const encodedPollId = encodeURIComponent(pollId);
    history.push(`/admin/${encodedPollId}`);
    
    setDrawerVisible(false);
  };

  return (    
    <SForm className='poll-selector' onSubmit={startPoll}>
      <p>Enter a name for your new poll: </p>
      <PollPickerInput
        inputPollName={inputPollName}
        startPoll={startPoll}
      />
    </SForm>
  );
};

const mapStateToProps = (state: IAppState) => state;

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    createPoll: (currentPollId: string, currentPollOwner: string) => {
      createPollFb(currentPollId, currentPollOwner)(dispatch);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPollDrawer);
